module.exports = __webpack_public_path__ + "static/media/logo.60744a1d.svg";